"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrCadOffPageConnectorNamingRule = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
class OrCadOffPageConnectorNamingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Naming;
    }
    apply(group, _hierarchy) {
        if (!group.hasLabelType('off-page-connector')) {
            return undefined;
        }
        const candidates = [];
        let shallowestAliasDepth;
        for (const [instance, nets] of group.getNets()) {
            const depth = instance.path.length;
            for (const net of nets) {
                for (const label of net.labels) {
                    if (label.labelType === 'off-page-connector') {
                        candidates.push({
                            name: label.formattedLabel ?? label.originalLabel,
                            depth,
                        });
                    }
                    else if (label.labelType === 'alias') {
                        if (shallowestAliasDepth === undefined || depth < shallowestAliasDepth) {
                            shallowestAliasDepth = depth;
                        }
                    }
                }
            }
        }
        if (candidates.length === 0) {
            return undefined;
        }
        candidates.sort((a, b) => {
            if (a.depth !== b.depth) {
                return a.depth - b.depth;
            }
            return sigma_engine_shared_1.Utils.naturalStringSort(a.name, b.name);
        });
        const shallowestOffPageDepth = candidates[0].depth;
        if (shallowestAliasDepth !== undefined && shallowestAliasDepth < shallowestOffPageDepth) {
            return undefined;
        }
        return candidates[0].name;
    }
}
exports.OrCadOffPageConnectorNamingRule = OrCadOffPageConnectorNamingRule;
//# sourceMappingURL=OrcadOffPageConnectorNamingRule.js.map